//Please add the language resource
const reshipCornPlanVehicle = {
  plantName:'基地',
  planNo:"计划单号",
  schNo:'车辆调度单',
  schStatusName:'调度状态',
  reshipDate: '倒运日期',
  vehicleNo: '车牌号',
  driverTel: '司机手机号',
  businessTypeName: '业务类型',
  goodsCategoryName: '货物类别',
  lotNo: '计划批次号',
  originStorageName: '出货库位',
  loadingTypeName: '装车工具',
  destStorageName: '收货库位',
  destUnloadBeginTime: '卸货开始时间',
  schSeq: '当日倒运顺序',
  planWeight: '计划量(吨)',
  netWeight: '实际量(吨)',
  msg:{
  }
};
export default reshipCornPlanVehicle



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornPlanVehicle/lang/reshipCornPlanVehicle.en.js